export default __webpack_public_path__ + "static/media/github-orange.cff19660.svg";